// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vue-node_modules_vue_dist_vue_esm_js","defaultVendors-node_modules_vue-loader_lib_runtime_componentNormalizer_js-node_modules_core-j-688de7"], function() { return __webpack_require__("./app/views/web/share/user/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
